module.exports = __webpack_public_path__ + "assets/start-2.45c2feaa.svg";